import axios from "axios";
import qs from "qs";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getAll = async ({
  filters,
  pageSize,
  currentPage
}) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets`,
      {
        params: {
          ...filters,
          pageSize,
          currentPage
        },
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      }
    );
    responseFormat.totalPages = data.totalPages;
    responseFormat.countItems = data.countItems;
    responseFormat.data = data.items;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.data = data;
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const getById = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/committee/meets/${id}`
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.data = data;
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const getMeetingInfoByid = async (culture, idMeeting) => {
  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${culture}/v1/Committee/meets/agenda/${idMeeting}`
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const deleteMeetingById = async (languageId, id) => {
  try {
    const { data } = await axios.delete(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/${id}`,
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const cancelMeetingById = async (languageId, id) => {
  try {
    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/${id}`,
      {},
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const cancelMeetingAgendaById = async (languageId, request) => {
  try {
    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/agenda/canceled`,
      request,
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const generateExcelDocument = async (id) => {
    const language = localStorage.getItem("i18nextLng");

  try {
    const response = await axios.get(
      `${API_BACKEND_HOST}${language}/v1/Committee/meets/agenda/${id}/excelfile`, { responseType: 'arraybuffer' }
    );

    return response;
  } catch ({ response }) {
    responseFormat.error = "error";

    return responseFormat;
  }
};

export const addMeeting = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets`,
      request,
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar criar a reunião";

    if (response.data.message === "{ message = Ocorrência Invalida, StatusCode = PreconditionFailed }") {
      responseFormat.error = "Ocorrência inválida.";
    }

    responseFormat.statusError = response.data.statusCode;

    return responseFormat;
  }
};

export const addAgenda = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/agenda`,
      request
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors.length > 0 ? response.data.errors : "Erro ao tentar criar a reunião";
    return responseFormat;
  }
};

export const addAgendaAppointment = async (id, request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/agenda/confirm-agenda-batch/${id}`,
      request,
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =  "Erro ao tentar confirmar a agenda.";
    return responseFormat;
  }
};

export const sendMeetingInvite = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.request({
      url: `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/send-invite-meet`,
      method: 'post',
      data: request,
    });

    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar enviar convite de reunião";
    return responseFormat;
  }
};

export const getMeetingTemplateagenda = async (request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const { data } = await axios({
      method: "GET",
      url: `${API_BACKEND_HOST}${languageId}/v1/Committee/template-agenda?commiitteeName=${request.committeName}&meetDate=${request.MeetDate}`,
      params: {
        meetId: request.meetId,
      },
      paramsSerializer: params => {
        return qs.stringify(params)
      },
      headers: {
        "Content-Type": "multipart/form-data",
        "accept": "application/json"
      },
    }
    );
    responseFormat.data = data;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error = "async";
    return responseFormat;
  }
};

export const updateMeeting = async (id, request) => {
  const languageId = localStorage.getItem("i18nextLng");
  try {
    const response = await axios.put(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meets/${id}`,
      request,
    );
    responseFormat.data = response;
    responseFormat.error = "";
    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar editar o reunião";
    return responseFormat;
  }
}

export const getMeetingInvite = async (id) => {
  const languageId = localStorage.getItem("i18nextLng");

  try {
    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Committee/meetInvite/${id}`
    );

    responseFormat.data = data;
    responseFormat.error = "";

    return responseFormat;
  } catch ({ response }) {
    responseFormat.error =
      response.data.errors || "Erro ao tentar editar o reunião";

    return responseFormat;
  }
};
